import { AbstractCollectionDirective } from './abstract-collection.directive';
import { Component } from '@angular/core';

@Component({
  templateUrl: './pilot-detail.component.html',
  styleUrls: ['./ie11-fixes.scss'],
})
export class PilotDetailComponent extends AbstractCollectionDirective {}
